var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("order-services", {
    ref: "orderServices",
    on: {
      saved: function($event) {
        return _vm.$router.push("/travel-service")
      },
      cancel: function($event) {
        return _vm.$router.push("/travel-service")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }